import script from "./FooterRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterRegister.vue?vue&type=script&setup=true&lang=js"

import "./FooterRegister.vue?vue&type=style&index=0&id=f54805d8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f54805d8"]])

export default __exports__